import { render } from "./WatchCategory.vue?vue&type=template&id=28247a34&scoped=true"
import script from "./WatchCategory.vue?vue&type=script&lang=js"
export * from "./WatchCategory.vue?vue&type=script&lang=js"

import "./WatchCategory.vue?vue&type=style&index=0&id=28247a34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28247a34"]])

export default __exports__